// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__4dm5o","dot":"Avatar_dot__1gnrb"};